export const styles = () => {
  return {
    bodyWrap: {
      display: "flex",
      flexDirection: "row !important",
      alignItems: "center",
    },
  };
};
